/*******************************************************************************
 * @ngdoc    object
 * @module   csm.books.services
 * @name     csm.books.services.NewBooksData.type:AccountType
 * @constructor
 * @param {object=} info  Item info read from database.
 * @description
 * `dbo.AccountTypes` table row.
 *******************************************************************************/
AccountTypeConfig.$inject = ['TypeFactoryProvider'];
/* @ngInject */ export function AccountTypeConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'NewBooksData.AccountType',
    $type: 'csm.booksdb.data.AccountType, CSMBooksDBCS',
    prototype: {
      type: null, // Account type name.
      side: 0, // Account ledger side (BooksDBConstants.AS).
      acctClass: 0, // Account class (BooksDBConstants.AC).
      subClass: 0, // Account sub-class (BooksDBConstants.ASC).
      displayOrder: 0, // unused?
      required: false, // true = Account of this type is required.
      single: false, // true = Only one account of this type is allowed.
      allowTransfer: false // unused?
    }
  });
}
